<app-all-offers-component />
